import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { SearchTintSvg } from "../../icons/Icon";
import { LoadingSvg, StarSvg, SearchSmallSvg, HeaderProfileSvg, HeaderOrdersSvg, HeaderWishListSvg, HeaderRewardsSvg, HeaderGiftCardSvg, HeaderDownSvg, HeaderCartSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { HOST } from "../../api/Api";
import { headerBarSearch } from "../../api/actions/SearchActions";
import { dispatch_headerSearch_Event, dispatch_ClearHeaderSearch_Event } from "../../events/SearchEvents";
import { getTopNCommonKeys } from "../../functions/common";

const SearchList = (p) => {

    return (
        Array.isArray(p.json) ?
            <ul className="headerSearchResult_ul">{p.json.map((item, index) => <li key={`${index}}-${item.match}`}><Link to={`/product/${item.productId}/${item.match}`} >{item.match}</Link></li>)}</ul>
            :
            <></>
    );
};
const TagList = (p) => {
    if (Array.isArray(p.json)) {
        var tags = p.json.map(j => j.tags);
        var common = getTopNCommonKeys(tags, 5);
        var keys = Object.keys(common);
        //console.log('tagList', tags, common);
    }

    return Array.isArray(keys) ?
        <ul className="headerSearchTags">{keys.map((key, index) => <li key={`${index}}-${key}`}><Link to={`/category/${(common[key] || '').toLowerCase()}`}>{common[key]}</Link></li>)}</ul>
        :
        <></>;
};
const showSearch = ({ state = null, payload = null } = { state: null, payload: null }) => {
    switch (state) {
        case 'loading':
            return <Loading><LoadingSvg /></Loading>;
        case 'done':
            return <>
                <SearchList json={payload} />
                <TagList json={payload} />
            </>;
        case 'error':
            return <></>;
        default:
            return <></>;
    }
};
function HeaderSearch() {


    const [term, setTerm] = useState(null);
    const headerSearchResults = useSelector(state => state.ui.ui_headerSearchBar);

    const handleChange = (e) => {
        setTerm(e?.target?.value || '');
        dispatch_headerSearch_Event(e);
    };
    function clearSearch(e) {
        //console.log('keyup', e.key);
        if (e.key == 'Escape') {
            setTerm(null);
            dispatch_ClearHeaderSearch_Event();
        }
    }

    useEffect(() => {
        window.document.addEventListener('keyup', clearSearch);
        return () => {
            window.document.removeEventListener('keyup', clearSearch);
        };
    },);
    return (
        <section className="header-search">
            <form action="" className="header-search-form">
                <input type="text" placeholder="Search for Products, Brands and More" onChange={handleChange} />
                <button><SearchTintSvg /></button>
            </form>
            <div className="headerSearchResult" onClick={() => setTerm(null)}>
                {showSearch(headerSearchResults)}
                {term && <div><Link to={`/filter/${term}`} ><SearchSmallSvg /><span>search more for {`"${term}"`}</span></Link></div>}
            </div>
        </section>
    );
}

function AppHeader(p) {

    const headerBar = useRef(null);

    useEffect(() => {
        window.makeSticky(headerBar.current);
    }, []);

    return (
        <header>
            <div ref={headerBar} className="header-bar-container" id="header-bar">
                <div className="header-bar">
                    <section className="header-logo"><Link to="/"><img src="/images/logo.svg" /><span><b>Star</b>Deal</span></Link></section>
                    <HeaderSearch />
                    <section className="header-actions">
                        <div className="header-action">
                            <a href="" onClick={(e) => e.preventDefault()}><HeaderProfileSvg /><span>Login</span>
                                <figure><HeaderDownSvg /></figure>
                            </a>
                            <nav className="login-menu">
                                <div><span>new customer ?</span><a href="">sign up</a></div>
                                <ul>
                                    <li><a href=""><HeaderProfileSvg /><span>My profile</span></a></li>
                                    <li><a href=""><HeaderOrdersSvg /><span>Orders</span></a></li>
                                    <li><a href=""><HeaderWishListSvg /><span>Wishlist</span></a></li>
                                    <li><a href=""><HeaderRewardsSvg /><span>Rewards</span></a></li>
                                    <li><a href=""><HeaderGiftCardSvg /><span>Gift cards</span></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="header-action">
                            <a href=""><HeaderCartSvg /><span>Cart</span></a>
                        </div>
                    </section>
                </div>
            </div>
        </header>
    );
}
/*
                    <section className="header-search">
                        <form action="" className="header-search-form">
                            <input type="text" placeholder="Search for Products, Brands and More" />
                            <button><img src="../website/public/images/header-search.svg" alt="" /></button>
                        </form>
                        <div className="header-search-result"></div>
                    </section>
                */
export default AppHeader;